<template>
    <div
        class="custom-tooltip shadow-[0px_3px_8px_0px_rgba(0,0,0,0.14)] overflow-y-auto"
        :class="`custom-tooltip-${theme !== 'dark' ? 'light' : 'dark'}`"
        :style="{
            maxWidth: '400px',
            maxHeight: '90vh',
        }"
    >
        <span v-safe-html="title" />
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    theme: 'light' | 'dark';
    title: string;
}>(), {
    theme: 'light',
});
</script>

<style lang="scss" scope>
.custom-tooltip {
    padding: 8px !important;
    border-radius: 4px !important;

    &.custom-tooltip-light {
        @apply bg-white text-black border border-gray-40;
    }

    &.custom-tooltip-dark {
        @apply bg-grey-450 text-white;
    }
}
</style>
